import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Paper, Alert, Fade } from '@mui/material';
import { API_CONFIG } from '../config/config';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const Activate = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const activationAttempted = useRef(false);

  useEffect(() => {
    const activateAccount = async () => {
      // Prevent multiple activation attempts
      if (activationAttempted.current) return;
      activationAttempted.current = true;

      try {
        const response = await fetch(`${API_CONFIG.BASE_URL}/auth/activate/${token}`, {
          method: 'GET',
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || 'Activation failed');
        }

        setStatus('success');
        setMessage('Konto erfolgreich aktiviert! Du kannst dich jetzt anmelden.');
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (error) {
        console.error('Activation error:', error);
        setStatus('error');
        setMessage(error.message || 'Aktivierung fehlgeschlagen. Der Link ist möglicherweise abgelaufen oder ungültig.');
      }
    };

    activateAccount();
  }, [token, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 400,
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        {status === 'loading' && (
          <Fade in={true} timeout={500}>
            <Box>
              <CircularProgress size={60} thickness={4} />
              <Typography variant="h6" sx={{ mt: 3, fontWeight: 500 }}>
                Konto wird aktiviert...
              </Typography>
            </Box>
          </Fade>
        )}
        {status === 'success' && (
          <Fade in={true} timeout={500}>
            <Box>
              <CheckCircleOutlineIcon 
                sx={{ 
                  fontSize: 60, 
                  color: 'success.main',
                  mb: 2
                }} 
              />
              <Alert 
                severity="success" 
                sx={{ 
                  mb: 2,
                  '& .MuiAlert-message': {
                    fontSize: '1.1rem',
                    fontWeight: 500
                  }
                }}
              >
                {message}
              </Alert>
              <Typography variant="body2" color="text.secondary">
                Weiterleitung zur Anmeldeseite...
              </Typography>
            </Box>
          </Fade>
        )}
        {status === 'error' && (
          <Fade in={true} timeout={500}>
            <Box>
              <ErrorOutlineIcon 
                sx={{ 
                  fontSize: 60, 
                  color: 'error.main',
                  mb: 2
                }} 
              />
              <Alert 
                severity="error" 
                sx={{ 
                  mb: 2,
                  '& .MuiAlert-message': {
                    fontSize: '1.1rem',
                    fontWeight: 500
                  }
                }}
              >
                {message}
              </Alert>
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ mt: 2 }}
              >
                Bitte versuche dich erneut zu registrieren oder kontaktiere hermann@cyberlagebild.de falls das Problem weiterhin besteht.
              </Typography>
            </Box>
          </Fade>
        )}
      </Paper>
    </Box>
  );
};

export default Activate; 